import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { MasterFooterPage } from './master-footer.page';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [MasterFooterPage],
  imports: [CommonModule, IonicModule, TranslateModule],
  exports: [MasterFooterPage],
})
export class MasterFooterModule {}
